import { render, staticRenderFns } from "./ItemAuctionLayout.vue?vue&type=template&id=0da33c72&scoped=true"
import script from "./ItemAuctionLayout.vue?vue&type=script&lang=js"
export * from "./ItemAuctionLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da33c72",
  null
  
)

export default component.exports